export default __webpack_public_path__ + "static/media/loader.669ab30e.gif";